import React from "react";
import * as contentful from "contentful-management";
import { connect, } from "react-redux";
import { Redirect, } from "react-router-dom";

import env from "../vars";

// --------------------------------------------------

class RT extends React.Component {
	state = {
		redirect: "",
	}

	componentDidMount() {
		if (window.location.hash.includes("#access_token=")) {
			const token = window.location.hash.split("&")[0].replace("#access_token=", "");
			console.log("token:", token);

			const client = contentful.createClient({
				accessToken: token,
			});
			client.getSpace(env.CONTENTFUL_SPACE_ID)
			.then(space => {
				this.props.dispatch({
					type: "SET_TOKEN",
					token,
				});
				this.props.dispatch({
					type: "SET_SPACE",
					space,
				});
				setTimeout(() => this.setState({ redirect: "/", }), 1000);
			})
			.catch(space => {
				console.log("issue with teh space:", space);
				setTimeout(() => this.setState({ redirect: "/login-error", }), 1000);
			});
		}
		else {
			setTimeout(() => this.setState({ redirect: "/login-error", }), 1000);
		}
	}

	render() {
		return (
			(this.state.redirect)
			? <Redirect to = { this.state.redirect }/>
			: <h1>Checking token...</h1>
		);
	}
}

export default connect()(RT);



// WEBPACK FOOTER //
// ./src/components/ReceiveToken.js